module.exports = __webpack_public_path__ + "img/aspect.bdaa1d2.png";